import React, { useState, useEffect } from 'react';
import gsap from 'gsap';

// Imágenes para el vaso
import vasoTop from '../assets/inicio/banner/vasokaliman/vaso-top.png';
import kalimanHuge from '../assets/inicio/banner/vasokaliman/kaliman-huge.jpg';

const AnimacionVasoKaliman = () => {
  //Variación de scale para Huge
  const [scale, setScale] = useState(1);

  // Función para actualizar escala según pantalla
  const getScale = (width) => {
    if (width >= 1400) return 0.9;     // pantallas grandes
    if (width >= 1200) return 0.5;     // desktop
    if (width >= 1024) return 0.86;    // desktop
    if (width >= 768) return 0.9;      // tablets
    return 0.9;                        // mobile
  };

  useEffect(() => {
    const updateScale = () => setScale(getScale(window.innerWidth));
    updateScale(); // inicial
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);


  //Variación para y
  //Variación de scale para Huge
  const [positiony, setPositiony] = useState(1);

  // Función para actualizar escala según pantalla
  const getPositiony = (width) => {
    if (width >= 1400) return '40px';    // pantallas grandes
    if (width >= 1200) return '30px';    // desktop
    if (width >= 1024) return '30px';    // desktop
    if (width >= 768) return '18px';     // tablets
    return 0.9;                          // mobile
  };

  useEffect(() => {
    const updatePositiony = () => setPositiony(getPositiony(window.innerWidth));
    updatePositiony(); // inicial
    window.addEventListener("resize", updatePositiony);
    return () => window.removeEventListener("resize", updatePositiony);
  }, []);

  useEffect(() => {
    const vasoMove = document.getElementById("vaso-move");
    if (!vasoMove) return;

    const maskImg = vasoMove.querySelector(".mask1 img");

    if (maskImg) {
      const tlImg = gsap.timeline({ repeat: -1, yoyo: false });
      tlImg
        // Establecer posición inicial: derecha inclinado
        .set(maskImg, {
          x: 80,
          y: positiony,
          scale: scale,
          rotate: -3,
          transformOrigin: "top center",
        })
        // Delay inicial
        .to(maskImg, { duration: 1 })
        // Ir al centro vertical
        .to(maskImg, {
          x: 0,
          y: positiony,
          scale: scale,
          rotate: 0,
          duration: 2,
          ease: "power2.out",
          transformOrigin: "top center",
          force3D: true
        })
        // Ir a la izquierda inclinado
        .to(maskImg, {
          x: -80,
          y: positiony,
          scale: scale,
          rotate: 3,
          duration: 2,
          ease: "power2.out",
          transformOrigin: "top center",
          force3D: true
        })
        // Regresar al centro vertical
        .to(maskImg, {
          x: 0,
          y: positiony,
          scale: scale,
          rotate: 0,
          duration: 2,
          ease: "power2.out",
          transformOrigin: "top center",
          force3D: true
        })
        // Regresar a la derecha inclinado (cierra el ciclo)
        .to(maskImg, {
          x: 80,
          y: positiony,
          scale: scale,
          rotate: -3,
          duration: 2,
          ease: "power2.out",
          transformOrigin: "top center",
          force3D: true
        });
    }

    const tlVaso = gsap.timeline({ repeat: -1, yoyo: false });
    tlVaso
      // Establecer posición inicial: derecha inclinado
      .set(vasoMove, {
        x: 400,
        rotate: 16
      })
      // Delay inicial
      .to(vasoMove, { duration: 1 })
      // Ir al centro vertical
      .to(vasoMove, {
        x: 0,
        rotate: 0,
        duration: 2,
        ease: "power2.out",
      })
      // Ir a la izquierda inclinado
      .to(vasoMove, {
        x: -400,
        rotate: -16,
        duration: 2,
        ease: "power2.out",
      })
      // Regresar al centro vertical
      .to(vasoMove, {
        x: 0,
        rotate: 0,
        duration: 2,
        ease: "power2.out",
      })
      // Regresar a la derecha inclinado (cierra el ciclo)
      .to(vasoMove, {
        x: 400,
        rotate: 16,
        duration: 2,
        ease: "power2.out",
      });
  }, []);
    
 
  return (
    <>
    <div id="vaso" className="wrap">
      {/*position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%) scale(1.5)', width:'360px', height:'445px', zIndex:'10'*/}
        <div id="vaso-move">
          <div className="mask1 kalimanvaso">
            <img src={kalimanHuge} className='stickkaliman' alt="Kaliman"/>
          </div>
          <img  src={vasoTop} className='vaso-top-kaliman'  alt="Vaso top" />
        </div>
    </div>
    </>
  );
};

export default AnimacionVasoKaliman;
